/**
 * Declare font sizes, families, etc. here so that the values can be generated for both PrimeNG & TailwindCSS
 */
export const typography: Typography = {
  fontSize: {
    xs: '1rem',
    sm: '1.2rem',
    base: '1.4rem',
    lg: '1.6rem',
    xl: '2rem',
    '2xl': '2.4rem',
    '3xl': '3.6rem',
    '4xl': '4.8rem',
    normalize: '62.5%', // Use this to normalize 1rem = 10px
    'normalize-laptop': '58.036%', // Effectively setting 1rem ≈ 9.286px (1.4rem ≈ 13px)
  },
  fontFamily: {
    'display-2': 'Oswald, sans-serif',
    display: 'Bebas Neue, sans-serif',
    body: 'Figtree, Open Sans, sans-serif',
  },
  letterSpacing: {
    tightest: '-.75px',
    tighter: '-.5px',
    tight: '-.25px',
    normal: '0',
    wide: '.25px',
    wider: '.5px',
    widest: '1px',
  },
};

export interface Typography {
  fontSize: {
    xs: string;
    sm: string;
    base: string;
    lg: string;
    xl: string;
    '2xl': string;
    '3xl': string;
    '4xl': string;
    normalize: string;
    'normalize-laptop': string;
  };
  fontFamily: Record<string, string>;
  letterSpacing: {
    tightest: string;
    tighter: string;
    tight: string;
    normal: string;
    wide: string;
    wider: string;
    widest: string;
  };
}